import Controller from '../core/Controller';
import URLUtils from '../util/URLUtils'
import InteractiveCatalogParser from '../parser/interactive/InteractiveCatalogParser';
import InteractiveCatalogPageParser from '../parser/interactive/InteractiveCatalogPageParser';
import InteractiveCatalogView from '../view/interactive/InteractiveCatalogView';
import GoToPageAction from '../model/interactive/actions/GoToPageAction';
import HideItemAction from '../model/interactive/actions/HideItemAction';
import ShowItemAction from '../model/interactive/actions/ShowItemAction';
import OpenWebAction from '../model/interactive/actions/OpenWebAction';
import PlayAudioAction from '../model/interactive/actions/PlayAudioAction';
import PauseAudioAction from '../model/interactive/actions/PauseAudioAction';
import ResumeAudioAction from '../model/interactive/actions/ResumeAudioAction';
import StopAudioAction from '../model/interactive/actions/StopAudioAction';
import PlayMovieAction from '../model/interactive/actions/PlayMovieAction';
import PauseMovieAction from '../model/interactive/actions/PauseMovieAction';
import ResumeMovieAction from '../model/interactive/actions/ResumeMovieAction';
import StopMovieAction from '../model/interactive/actions/StopMovieAction';
import ToggleMenuAction from '../model/interactive/actions/ToggleMenuAction';
import ExitCatalogAction from '../model/interactive/actions/ExitCatalogAction';
import GoToStateAction from '../model/interactive/actions/GoToStateAction';
import GoToNextStateAction from '../model/interactive/actions/GoToNextStateAction';
import GoToPreviousStateAction from '../model/interactive/actions/GoToPreviousStateAction';
import OpenCatalogAction from '../model/interactive/actions/OpenCatalogAction';
import CSSEffects from '../util/CSSEffects';

export default class InteractiveCatalogController extends Controller {

    constructor() {
        super();
    }

    load(libraryCatalog) {

        let url = libraryCatalog.path;
        if (url.search('http') < 0) {
            let path = this.app.baseUrl + libraryCatalog.path;
            url = URLUtils.getURL(path);
        }

        $.get(url, (data) => {

            let parser = new InteractiveCatalogParser();

            this.interactiveCatalog = parser.parse(data);

            let deferred = new $.Deferred();
            let promise = deferred;

            if (this.app.library.expandPagesXml) {
                for (let i = 0; i < this.interactiveCatalog.numPages; i++) {
                    promise = promise.then(() => {
                        let pageUrl = url.replace(".xml", "-page-"+i+".xml");
                        return $.get(pageUrl, (data) => {
                            let xml = $(data);
                            let elem = xml.children().first();
                            this.interactiveCatalog.pages.push(InteractiveCatalogPageParser.parse(elem));
                        });
                    });
                }
            }

            promise.then(() => {
                console.log(this.interactiveCatalog);
                this.view = new InteractiveCatalogView();
                this.getApp().renderView(this.view, {
                    'library': this.app.library,
                    'baseUrl': this.app.baseUrl,
                    'visualTemplate': this.app.visualTemplate,
                    'libraryCatalog': libraryCatalog,
                    'interactiveCatalog': this.interactiveCatalog
                });
            });

            deferred.resolve();

        });
    }

    doAction(itemAction) {
        console.log(itemAction);

        if (itemAction instanceof GoToPageAction) {
            this.interactiveCatalog.goToPage(itemAction.page);
            this.view.render();
        }

        if (itemAction instanceof HideItemAction) {

            let targetItem = this.interactiveCatalog._items[itemAction.itemId];

            if (itemAction.animationType == 'EASE_OUT') targetItem.fadeOut(1000);
            else if (itemAction.animationType == 'FLIP_LEFT') CSSEffects.hideFlipLeft(targetItem);
            else if (itemAction.animationType == 'FLIP_RIGHT') CSSEffects.hideFlipRight(targetItem);
            else targetItem.hide();
        }

        if (itemAction instanceof ShowItemAction) {

            let targetItem = this.interactiveCatalog._items[itemAction.itemId];

            if (itemAction.animationType == 'EASE_OUT') targetItem.fadeIn(1000);
            else if (itemAction.animationType == 'FLIP_LEFT') CSSEffects.showFlipLeft(targetItem);
            else if (itemAction.animationType == 'FLIP_RIGHT') CSSEffects.showFlipRight(targetItem);
            else targetItem.show();
        }

        if (itemAction instanceof OpenWebAction) {
            window.open(itemAction.url, '_blank');
        }

        if (itemAction instanceof PlayAudioAction) {
            let audio = this.interactiveCatalog._items[itemAction.itemId].find('audio')[0];
            if (audio.paused) audio.currentTime = 0;
            audio.play();
        }

        if (itemAction instanceof PauseAudioAction) {
            let audio = this.interactiveCatalog._items[itemAction.itemId].find('audio')[0];
            audio.pause();
        }

        if (itemAction instanceof ResumeAudioAction) {
            let audio = this.interactiveCatalog._items[itemAction.itemId].find('audio')[0];
            audio.play();
        }

        if (itemAction instanceof StopAudioAction) {
            let audio = this.interactiveCatalog._items[itemAction.itemId].find('audio')[0];
            audio.pause();
            audio.currentTime = 0;
        }

        if (itemAction instanceof PlayMovieAction) {
            let itemDiv = this.interactiveCatalog._items[itemAction.itemId];
            if (!itemDiv.is(":visible")) itemDiv.show();

            let video = itemDiv.find('video')[0];
            if (video.paused) video.currentTime = 0;
            video.play();
        }

        if (itemAction instanceof PauseMovieAction) {
            let itemDiv = this.interactiveCatalog._items[itemAction.itemId];
            let video = itemDiv.find('video')[0];
            video.pause();
        }

        if (itemAction instanceof ResumeMovieAction) {
            let itemDiv = this.interactiveCatalog._items[itemAction.itemId];
            if (!itemDiv.is(":visible")) itemDiv.show();
            
            let video = itemDiv.find('video')[0];
            video.play();
        }

        if (itemAction instanceof StopMovieAction) {
            let itemDiv = this.interactiveCatalog._items[itemAction.itemId];
            let video = itemDiv.find('video')[0];
            video.pause();
            video.currentTime = 0;
        }

        if (itemAction instanceof ToggleMenuAction) {
            $('#toolbar').fadeToggle();
        }

        if (itemAction instanceof ExitCatalogAction) {
            this.app.goBack();
        }

        if (itemAction instanceof GoToStateAction) {
            let itemDiv = this.interactiveCatalog._items[itemAction.itemId];
            let item = itemDiv._item;
            item.goToState(itemAction.stateName);
            item.refresh(itemDiv);
        }

        if (itemAction instanceof GoToNextStateAction) {
            let itemDiv = this.interactiveCatalog._items[itemAction.itemId];
            let item = itemDiv._item;
            item.goToNextState(itemAction.stopInLast);
            item.refresh(itemDiv);
        }

        if (itemAction instanceof GoToPreviousStateAction) {
            let itemDiv = this.interactiveCatalog._items[itemAction.itemId];
            let item = itemDiv._item;
            item.goToPreviousState(itemAction.stopInFirst);
            item.refresh(itemDiv);
        }

        if (itemAction instanceof OpenCatalogAction) {
            this.app.loadCatalogById(itemAction.catalogId, true);
        }

    }

}
